export default class ConditionDto {
    constructor() {
        this.id = 0;
        this.rule = null;
        this.valueSettings = null;
        this.operator = null;
        this.expectedValueSettings = null;
        this.position = 1;
        this.actions = [];
    }
}
//# sourceMappingURL=condition-dto.js.map